import { Types } from '../actions/types'
import initialState from '../store/initial.state'

export const appDataReducer = (state = initialState.dataReducer, action) => {
  switch (action.type) {
    // case Types.SALES_DATA: {
    //     let data = action.payload
    //     return {
    //         ...state,
    //         salesData: data
    //     }
    // }
    default:
      return state
  }
}
